import { Component as t } from "react";

var n = function n() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
    n[r] = arguments[r];
  }

  return function () {
    for (var t = arguments.length, r = new Array(t), e = 0; e < t; e++) {
      r[e] = arguments[e];
    }

    return n.forEach(function (t) {
      return t && t.apply(void 0, r);
    });
  };
},
    r = function (t) {
  var r, e;

  function a() {
    for (var r, e = arguments.length, a = new Array(e), o = 0; o < e; o++) {
      a[o] = arguments[o];
    }

    return (r = t.call.apply(t, [this].concat(a)) || this).state = {
      invalid: !1
    }, r.handleOnInvalid = function (t) {
      var n = t.target;
      r.setState({
        invalid: !0
      }), null != r.props.errorMessage && n.setCustomValidity(r.props.errorMessage);
    }, r.handleOnChange = function (t) {
      var n = t.target;
      r.setState({
        invalid: !1
      }), null != r.props.errorMessage && n.setCustomValidity("");
    }, r.getInputProps = function (t) {
      return {
        onInvalid: n(r.handleOnInvalid, (t || {}).onInvalid),
        onChange: n(r.handleOnChange, (t || {}).onChange)
      };
    }, r;
  }

  return e = t, (r = a).prototype = Object.create(e.prototype), r.prototype.constructor = r, r.__proto__ = e, a.prototype.render = function () {
    return this.props.children(this.getInputProps, this.state.invalid);
  }, a;
}(t);

export default r;